import { HiddenReason, WheelGeneRef } from './Panel';

export interface Trait {
    idtraits: number;
    trait_panel: string;
    trait_name: string;
    trait_desc: string | null;
    trait_searcher: string | null;
    lifetime_risk: string | null;
    trait_treatment: string | null;
    // Virtual properties
    snp_count?: number;
    // A4/A5: GET /panels/{id}/traits attaches the trait's gene ring — server rows first, then derived.
    genes?: WheelGeneRef[];
    is_hidden?: boolean;
    hidden_reason?: HiddenReason | null;
}

export interface TraitSummary {
    id: number;
    name: string;
    panel: string;
    description: string | null;
    lifetime_risk: string | null;
    snp_count: number;
    gene_count: number;
    genes: string[];
    quality_distribution: Record<string, number>;
}

export const defaultTrait: Trait = {
    idtraits: 0,
    trait_panel: '',
    trait_name: '',
    trait_desc: null,
    trait_searcher: null,
    lifetime_risk: null,
    trait_treatment: null
};